<template>
  <v-form
    v-model="valid"
    ref="form"
  >
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <h1>NEO Profil</h1>
          <img :src="$auth.user.picture" />
          <h2>{{ $auth.user.email }}</h2>
          <v-text-field
            v-model="user.firstName"
            :rules="nameRules"
            label="Fornavn"
            required
          ></v-text-field>
          <v-text-field
            v-model="user.lastName"
            :rules="nameRules"
            label="Efternavn"
            required
          ></v-text-field>
          <v-text-field
            v-model="user.email"
            label="Email"
            readonly
          ></v-text-field>
          <v-text-field
            v-model="user.address"
            label="Adresse"
          ></v-text-field>
          <v-text-field
            v-model="user.address2"
            label="Adresse"
          ></v-text-field>
          <v-text-field
            v-model="user.zip"
            label="Postnr"
          ></v-text-field>
          <v-text-field
            v-model="user.city"
            label="By"
          ></v-text-field>
          <v-text-field
            v-model="user.country"
            label="Land"
          ></v-text-field>
          <v-text-field
            v-model="user.phone"
            :rules="phoneRules"
            label="Mobil"
            required
          ></v-text-field>
          <v-text-field
            v-model="user.company"
            label="Firma"
          ></v-text-field>
          <v-text-field
            v-model="user.vat"
            label="CVR"
          ></v-text-field>

          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="save"
          >Gem</v-btn>

          <!--   <pre>{{ JSON.stringify(user, null, 2) }}</pre>-->
        </v-col>
      </v-row>

      <v-snackbar
        v-model="showSnackbar"
        :multi-line="false"
        :timeout="5000"
        dark
        color="#EE765E"
        class="title"
      >
        {{ snackbarText }}
        <v-btn
          color="white"
          text
          @click="showSnackbar = false"
        >Luk</v-btn>
      </v-snackbar>
    </v-container>
  </v-form>
</template>

<script>
// import {    EventBus} from './../../event-bus.js';

import store from "./../../store";
import core from "./../../mixins/core";

export default {
  data: function () {
    return {
      showSnackbar: false,
      snackbarText: "",
      valid: false,
      user: {
        email: "",
        firstName: "",
        lastName: "",
        phone: "",
      },
      phoneRules: [
        (v) => !!v || "Telefon er påkrævet",
        (v) => v.length >= 8 || "Skal være min 8 tal",
      ],
      nameRules: [
        (v) => !!v || "Navn er påkrævet",
        //v => v.length <= 10 || 'Name must be less than 10 characters',
      ],
      emailRules: [
        (v) => !!v || "Email er påkrævet",
        (v) => /.+@.+/.test(v) || "Email skal være gyldig",
      ],
    };
  },
  mixins: [core],
  mounted() {
    this.user = store.getters.currentUser;
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setUser") {
        this.user = state.currentUser;
        this.$refs.form.validate();

        if (!this.isUserDetailsValid(state.currentUser)) {
          this.fillOutDetails();
        }
      }
    });

    if (this.$route.params.fillOutName) {
      this.fillOutDetails();
      this.$refs.form.validate();
    }

    //  EventBus.$on('fillOutName', this.fillOutName);
    //        this.user.email = "123";
    //         console.log(this.user.email);
  },
  methods: {
    fillOutDetails() {
      this.showSnackbar = true;
      this.snackbarText =
        "Din profil mangler at få udfyldt et eller flere punkter";
    },
    save() {
      this.addUpdateUser(this.user).then((user) => {
        store.commit("setUser", user);
        this.showSnackbar = true;
        this.snackbarText = "Profil gemt";
      });
    },
  },
  name: "Profile",
};
</script>
